import { render, staticRenderFns } from "./emailtemplatemanager.vue?vue&type=template&id=51f15f82&lang=pug"
import script from "./emailtemplatemanager.vue?vue&type=script&lang=js"
export * from "./emailtemplatemanager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports